var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCvv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.89153 11.2196C9.64159 11.2196 11.871 8.99023 11.871 6.24017C11.871 3.49011 9.64159 1.26074 6.89153 1.26074C4.14147 1.26074 1.91211 3.49011 1.91211 6.24017C1.91211 8.99023 4.14147 11.2196 6.89153 11.2196Z",
    fill: "#A9A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89935 7.60952C4.80474 7.60952 4.71013 7.57468 4.63544 7.49999L3.63955 6.50411C3.49515 6.3597 3.49515 6.12066 3.63955 5.97626L4.63544 4.98037C4.77984 4.83597 5.01885 4.83597 5.16326 4.98037C5.30766 5.12478 5.30766 5.36382 5.16326 5.50822L4.43128 6.24018L5.16326 6.97214C5.30766 7.11655 5.30766 7.35559 5.16326 7.49999C5.08856 7.57468 4.99396 7.60952 4.89935 7.60952Z",
    fill: "#A9A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88393 7.60952C8.78932 7.60952 8.69471 7.57468 8.62002 7.49999C8.47562 7.35559 8.47562 7.11655 8.62002 6.97214L9.352 6.24018L8.62002 5.50822C8.47562 5.36382 8.47562 5.12478 8.62002 4.98037C8.76442 4.83597 9.00344 4.83597 9.14784 4.98037L10.1437 5.97626C10.2881 6.12066 10.2881 6.3597 10.1437 6.50411L9.14784 7.49999C9.07315 7.57468 8.97854 7.60952 8.88393 7.60952Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39208 7.77269C6.34229 7.77269 6.2925 7.76273 6.24768 7.74282C6.05846 7.66315 5.96883 7.44406 6.05348 7.24986L7.04937 4.92445C7.12904 4.73523 7.34813 4.64559 7.53735 4.73024C7.72657 4.80991 7.8162 5.02903 7.73155 5.22323L6.73566 7.54861C6.67591 7.68804 6.53649 7.77269 6.39208 7.77269Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvv);
export default __webpack_public_path__ + "static/media/CVV.bdf78b453ccbb0d9ed3d0f2f7069ec77.svg";
export { ForwardRef as ReactComponent };